// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"G5-z"};